import React from 'react';
import cn from 'classnames';

import {EEventSource} from 'coreClasses/events/IEvents';
import {useProduct} from 'coreHooks';

import {ProductHitComponent} from 'brandComponents/ProductHit';
import ProductTile from 'brandComponents/ProductTile';
import {DEFAULT_PRODUCT_HIT_COMPONENTS} from 'brandConstants';

import {IProductIncludeProps} from './IProductInclude';

import styles from './ProductInclude.module.scss';

const ProductInclude = (props: IProductIncludeProps) => {
	const product = useProduct(props.product?.items[0]?.id);
	const productHitComponents = props?.productHitComponentsCollection?.items
		?? DEFAULT_PRODUCT_HIT_COMPONENTS as ProductHitComponent[];

	return (
		<ProductTile
			productId={product.getProductId()}
			productHitComponents={productHitComponents}
			customProductMediaType={props.mediaType}
			productCoverMedia={props.productCoverMedia}
			hasDescription
			hideReadMore
			classNames={cn(
				'product-include',
				styles['product-include'],
				props.style,
				props.classNames
			)}
			source={EEventSource.PLP}
			index={props.index}
		/>
	);
};

export default ProductInclude;
